import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { OracleServiceCloudObjectDataset } from 'app/model/dataset/oracle-service-cloud.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'OracleServiceCloudSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(OracleServiceCloudObjectDataset) }
})
export class OracleServiceCloudCopySource extends TabularCopySource {
}
